module.exports = __webpack_public_path__ + "static/media/Multired-full-color2-1024x384.ff395252.png";